module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.type == 'unhead') ? _c('li', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "user"
  }, [_vm._v(_vm._s(_vm.data.user) + " "), (this.time != 'bottom') ? _c('small', {
    staticClass: "pull-right time"
  }, [_vm._v(_vm._s(_vm._f("goodTime")(_vm.data.time)))]) : _vm._e()]), _vm._v(" "), _vm._t("body"), _vm._v("\n\t\t" + _vm._s(_vm.data.content) + "\n\t\t"), (this.time == 'bottom') ? _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("goodTime")(_vm.data.time)))]) : _vm._e()], true)]) : _c('li', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_vm._t("left"), _vm._v(" "), (!!_vm.data) ? [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object",
    class: [{
      'img-circle': _vm.circle
    }],
    attrs: {
      "src": require("../../../assets/imgs/profilepicture.jpg")
    }
  })])] : _vm._e()], true), _vm._v(" "), _c('div', {
    staticClass: "media-body",
    class: {
      'media-middle': _vm.middle
    }
  }, [_vm._t("body"), _vm._v(" "), (!!_vm.data) ? [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.data.username))]), _vm._v(" " + _vm._s(_vm.data.content) + "\n\t\t\t"), (!_vm.hasright) ? _c('p', [_c('span', {
    staticClass: "pull-right time"
  }, [_vm._v(_vm._s(_vm._f("goodTime")(_vm.data.time)))])]) : _vm._e()] : _vm._e()], true), _vm._v(" "), (!!_vm.hasright) ? _c('div', {
    staticClass: "media-right"
  }, [_vm._t("right"), _vm._v(" "), (!!_vm.data) ? [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("goodTime")(_vm.data.time)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('badges', {
    attrs: {
      "max": 99,
      "val": _vm.data.msgcount,
      "imp": ""
    }
  }), _vm._v(" "), _vm._t("default")] : _vm._e()], true) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-c0174eb4!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/list/media.vue
// module id = 334
// module chunks = 2